module.exports = __webpack_public_path__ + "media/images/icon_list/filter-bfb41c9aee110128c7e7e94151958765.svg";